<template>
  <div>
    <div class="voucher-inner-wrap">
      <nav class="ticket-tab">
        <ul>
          <li :class="selectedTabClass('wavve')">
            <a href="#" @click.prevent="moveToVoucher('wavve')">웨이브</a>
          </li>
          <li :class="selectedTabClass('partner')">
            <a href="#" @click.prevent="moveToVoucher('partner')">제휴</a>
          </li>
        </ul>
      </nav>
      <wavve-voucher-list
        v-if="voucherType === 'wavve'"
        :voucher-purchase-fn="onClickProduct"
        :wavve-voucher-list="wavveVoucherList"
        :body-description-list="bodyDescriptionList"
        :get-value-fn="getValue"
        :set-number-commas-fn="setNumberCommas"
      />
      <partner-voucher-list
        v-else
        :voucher-purchase-fn="voucherPurchase"
        :get-value-fn="getValue"
        :partner-voucher-list="partnerVoucherList"
        :set-number-commas-fn="setNumberCommas"
      />
    </div>
    <voucher-remind />
    <popup-change-upcoming-payment
      v-if="isShowConfirmPopup"
      :voucher-info="upcomingVoucherInfo"
      @click-submit="changePurchase"
      @click-close="isShowConfirmPopup = false"
    />
    <loading-bar v-if="isLoading" />
  </div>
</template>
<script>
  import VoucherRemind from '@/components/voucher/VoucherRemind'
  import WavveVoucherList from '@/components/voucher/WavveVoucherList'
  import PartnerVoucherList from '@/components/voucher/PartnerVoucherList'
  import PopupChangeUpcomingPayment from '@/components/voucher/PopupChangeUpcomingPayment.vue'
  import LoadingBar from '@/components/ui/LoadingBar/LoadingBar.vue'
  import { getCheckPurchaseAction } from '@/common/requests/data-fetch/get-check-purchase-action'
  import {
    showBillingPopup,
    setNumberCommas,
    setDisableScrolling,
    titleTagNameChange,
    showRequiredLoginPopup,
  } from '@/common/utils/common'
  import braze from '@/common/utils/braze'
  import {
    normalizePurchaseParams,
    getPurchaseProperties,
  } from '@/common/utils/braze.util'
  import queryString from '@/common/utils/querystring'
  import { getVoucherPurchase } from '@/common/utils/request'
  import _ from 'lodash'
  import { multiProfileAutoLogin } from '@/common/utils/login'
  import { PURCHASE_ACTION_TYPE } from '@/common/normalize/normalize-check-purchase-Action'
  import { PATH_NAME_SUBSCRIPTION_TICKET } from '@/common/resources/router.const'
  import cookie from '@/common/utils/cookie'
  import { putUpcomingPayments } from '@/common/requests/data-fetch/put-upcoming-payments'
  import {
    MSG_COUPON_SERVER_ERROR,
    MSG_CHECK_PURCHASE_NETWORK_ERROR,
  } from '@/common/utils/coupon/const'

  export default {
    components: {
      WavveVoucherList,
      PartnerVoucherList,
      VoucherRemind,
      PopupChangeUpcomingPayment,
      LoadingBar,
    },
    data() {
      return {
        voucherType: 'wavve',
        wavveVoucherList: [],
        partnerVoucherList: [],
        bodyDescriptionList: [],
        dataList: [],
        isShowConfirmPopup: false,
        upcomingVoucherInfo: {},
        isLoading: false,
      }
    },
    watch: {
      $route() {
        this.setData()
      },
    },
    created() {
      window.addEventListener('message', this.postMessage)
      this.setData()
      setDisableScrolling(false)
      titleTagNameChange('이용권 구매 : 웨이브 이용권')
    },
    beforeDestroy() {
      window.removeEventListener('message', this.postMessage)
    },
    methods: {
      voucherFormatList(voucherList, descriptionList) {
        return descriptionList.map((description) => {
          let voucherObj = {}
          voucherObj['title'] = _.get(description, 'title', '')
          voucherObj['type'] = _.get(description, 'type', '')
          voucherList.forEach((voucher) => {
            const concurrency = _.get(voucher, 'concurrency.0', [])
            voucherObj[_.get(concurrency, 'product_name', '')] = _.get(
              concurrency,
              [_.get(description, 'key', '')],
              '',
            )
          })
          return voucherObj
        })
      },
      moveToVoucher(voucherType) {
        this.$router.push('/voucher/index?voucherType=' + voucherType)
      },
      selectedTabClass(voucherType) {
        return this.voucherType === voucherType ? 'selected' : ''
      },
      setNumberCommas(price) {
        return setNumberCommas(price)
      },
      async checkPurchaseAction(voucherInfo) {
        const { productid: productId } = voucherInfo
        this.isLoading = true
        const checkPurchaseResult = await getCheckPurchaseAction({ productId })
        this.isLoading = false
        if (!checkPurchaseResult || !checkPurchaseResult.data) {
          return {
            actionType: 'error',
            requestProductInfo: {},
          }
        }
        return checkPurchaseResult.data
      },
      async onClickProduct(voucherInfo) {
        if (cookie.getCredential() === 'none') {
          return showRequiredLoginPopup()
        }
        const { actionType, requestProductInfo } =
          await this.checkPurchaseAction(voucherInfo)

        const { PAYLETTER_CALL, PUT_UPCOMING_PAYMENTS } = PURCHASE_ACTION_TYPE
        switch (actionType) {
          case PAYLETTER_CALL: {
            this.voucherPurchase(voucherInfo)
            return
          }
          case PUT_UPCOMING_PAYMENTS: {
            this.isShowConfirmPopup = true
            this.upcomingVoucherInfo = { voucherInfo, requestProductInfo }
            return
          }
          default: {
            alert(MSG_CHECK_PURCHASE_NETWORK_ERROR)
          }
        }
      },
      async voucherPurchase(voucherInfo) {
        const concurrency = _.get(voucherInfo, 'concurrency.0', {})
        const isExternal =
          _.get(concurrency, 'is_product_external', 'n').toUpperCase() === 'Y'
        const linkTarget = _.get(concurrency, 'external_link_target', '')
        const externalUrl = _.get(concurrency, 'external_link_pc', '')
        const productId = _.get(concurrency, 'productid', '')
        if (isExternal) {
          window.open(externalUrl, linkTarget)
        } else {
          let locationOrign = window.location.origin
          if (!locationOrign) {
            locationOrign =
              window.location.protocol + '//' + window.location.hostname
          }
          const returnUrl = queryString.concatParams(
            locationOrign + '/callback.html?action=purchaseComplete',
            normalizePurchaseParams({ ...voucherInfo, ...concurrency }),
          )
          const canceledUrl = locationOrign + '/callback.html?action=Cancel'
          showBillingPopup({
            productId,
            productType: 'all',
            returnUrl,
            canceledUrl,
          })
        }
      },
      async changePurchase({ productCode: productId }) {
        const result = await putUpcomingPayments({ productId })
        this.isShowConfirmPopup = false
        if (result?.error) {
          alert(MSG_COUPON_SERVER_ERROR)
          return
        }
        this.$router.push({ name: PATH_NAME_SUBSCRIPTION_TICKET })
      },
      async postMessage(e) {
        if (e.origin === location.origin) {
          if (e.data?.eventMessage === 'purchaseComplete') {
            if (e.data?.params?.result === 'y') {
              braze.purchase(getPurchaseProperties(e.data?.params))
            }
            await multiProfileAutoLogin()
            this.setData()
          }
        }
      },
      getValue(voucher, key) {
        return _.get(voucher, ['concurrency', '0', key], '')
      },
      setData() {
        getVoucherPurchase().then(({ data }) => {
          this.dataList = JSON.parse(_.get(data, 'data.json'))
          this.voucherType = _.get(this.$route, 'query.voucherType', 'wavve')
          const wavveVoucherIndex = _.findIndex(this.dataList, {
            passgroup_type: 'wavve',
          })
          const partnerVoucherIndex = _.findIndex(this.dataList, {
            passgroup_type: 'partner',
          })
          this.wavveVoucherList = _.get(
            this.dataList,
            [[wavveVoucherIndex], 'productgroups', '0', 'products'],
            [],
          )
          this.partnerVoucherList = _.get(
            this.dataList,
            [[partnerVoucherIndex], 'productgroups', '0', 'products'],
            [],
          )
          this.bodyDescriptionList = _.get(
            this.dataList,
            [
              this.voucherType === 'wavve'
                ? wavveVoucherIndex
                : partnerVoucherIndex,
              'description_list',
              '0',
              'pc',
            ],
            [],
          )
        })
      },
    },
  }
</script>
<style lang="scss" src="@/assets/scss/category/ticket.scss"></style>
